module.exports = __webpack_public_path__ + "static/media/departure-icon.4c75565b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/departure-icon.svg
// module id = 792
// module chunks = 0